import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "use-scroll-to-top"
    }}>{`use-scroll-to-top`}</h1>
    <p>{`Description`}</p>
    <p>{`Our hook`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from "react";
import { useScrollToTop } from "react-hooks-lab";

const ScrollToTop = () => {
  useScrollToTop();

  useEffect(() => {
    // your stuff
  }, []);
};
`}</code></pre>
    <p>{`If you need a react-router scroll restoration just do it like this`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/docs/guides/scroll-restoration.md"
      }}>{`Reference`}</a></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from "react";

const ScrollToTop = ({ children, location: { pathname } }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return children || null;
};

export default withRouter(ScrollToTop);
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      